<header [ngClass]="showLanguageSwitcher ? 'language-switcher-grid justify-center logo w100 relative' : 'logo flex justify-center w100 relative'">
  @if (showBackButton) {
    <div>
      <button (click)="backClicked()" class="back-icon absolute">
        <img src="./assets/icons/Back-icon.svg" alt="back icon" width="24" height="24">
      </button>
    </div>
  }

  <div class="flex justify-center logo-image">
    <img src="./assets/img/IDP-Logo.svg" alt="logo" width="98" height="38">

  </div>
  @if (showLanguageSwitcher) {
    <div class="lang-swit">
      <div class="lang-swit-tit">Language</div>
      <mat-form-field appearance="outline" class="slct-boxes">
        <mat-select (selectionChange)="languageChange($event)" [(ngModel)]="defaultLanguage" required
          placeholder="Please select" panelClass="lang-select-panel">
          @for (lang of languageData.langVal; track lang) {
            <mat-option [value]="lang.val">{{lang.lang}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</header>